<su-headline h="h1" skin="primary">{{ 'menu.tenant_invoices.component.settings' | translate }}</su-headline>

<su-headline h="h2" skin="primary">{{formModel?.organisationName}}</su-headline>

<su-card [card]="cardInvoiceSettings"> 
    <div card-content>
        <formly-form [form]="form" [fields]="formFields" [model]="formModel">
        </formly-form>
    </div>
</su-card>

<app-spinner-overlay [show]="isLoading"></app-spinner-overlay>  

<ng-template #hintValidationUnknown let-field="field">
    <mat-hint>
        {{ 'invoice.settings.hint__emailVanidationUnknown' | translate }}
   </mat-hint>
</ng-template>

<ng-template #hintValidated let-field="field">
    <mat-hint style="color: green;">
        {{ 'invoice.settings.hint__emailValidated' | translate }}
   </mat-hint>
</ng-template>

<ng-template #hintNotValidated let-field="field">
    <mat-hint style="color: red;">
        {{ 'invoice.settings.hint__emailNotValidated' | translate }} 
   </mat-hint>
</ng-template>

